export default [
  {
    path: "/acts/joinUs",
    name: "JoinUs",
    meta: {
      title: "加盟合作",
      // requireAuth: true
    },
    component: () => import("./joinUs/index.vue")
  }
];